var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToiletAccessibleinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 11,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  strokeLinejoin: "round",
  d: "m54 52-4.103 1.368a2 2 0 0 1-2.53-1.265l-4.911-14.735A2 2 0 0 0 40.558 36h-11.88a2 2 0 0 1-1.97-1.652L24 19m2 7h10m-16.734 2.145c-4.938 2.86-8.26 8.202-8.26 14.32C11.006 51.596 18.409 59 27.542 59c5.994 0 11.243-3.19 14.143-7.963"
}))));
export default SvgToiletAccessibleinline;